module.exports = __webpack_public_path__ + "static/media/kllect_screen_recording.0b81f6ff.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kllect_screen_recording.gif
// module id = 282
// module chunks = 0